var $a61375bbb065e4f1$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log('Hash commit: ', "970396871035e04b64c661c3f5a68d6727e2635d");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();


//# sourceMappingURL=a-shoot.d57e8ea3.js.map
